












































import { Vue, Component } from 'vue-property-decorator';
import { Getter, State } from 'vuex-class';

import Builder from '@/utils/Builder';
import RiskResources from '@/services/RiskResources';

import { WPPost } from '@/common/RiskResources';

import Welcome from '@/components/RiskResources/Welcome.vue';
import OnDemandWebinarCard from '@/components/RiskResources/OnDemandWebinarCard.vue';

@Component({
	name: 'OnDemandWebinarsHome',
	components: {
		Welcome,
		OnDemandWebinarCard,
	},
})
export default class OnDemandWebinarsHome extends Vue {
	@State('webinars', { namespace: 'RiskResources' }) private webinars: WPPost[];
	@State('webinar_categories', { namespace: 'RiskResources' })
	private webinarCategories: WPPost[];
	private Builder: typeof Builder = Builder;
	private RiskResources: typeof RiskResources = RiskResources;

	private categoryFilter: number[] = [];

	/**
	 * Make sure that we show the correct claim reviews for the
	 * current brand.
	 */
	get showCorrectBrand() {
		return this.webinars.filter(claim => RiskResources.brandHasAccess(claim)) || [];
	}

	get filterWebinars() {
		const correctBrand = this.showCorrectBrand;

		if (this.categoryFilter.length === 0) {
			return correctBrand;
		}

		const items = [];
		this.categoryFilter.map(id => {
			correctBrand.map(item => {
				if (item.webinar_categories.includes(id)) {
					items.push(item);
				}
			});
		});

		return this.getUnique(items);
	}

	private getUnique(arr) {
		const set = new Set();
		return arr
			.map((v, index) => {
				if (set.has(v.id)) {
					return false;
				} else {
					set.add(v.id);
					return index;
				}
			})
			.filter(e => e || e === 0)
			.map(e => arr[e]);
	}
}
